import React from 'react';
import { Form } from 'react-bootstrap'
import QuestionTpl from '../templates/QuestionTpl'

export default class PayCycleQn extends React.Component {

    static id = 'pay_cycle';
    static defaultValue = 'Fortnightly';

    render() {
        const { id, value, onChange } = this.props;

        return (
            <QuestionTpl
                {...this.props}
                title="Pay Cycle"
                description="Your pay cycle"
                fineprint="This is how often you are paid."
                component={(props) => (
                    <Form.Group>
                        <Form.Control as="select"
                            value={value}
                            onChange={(e) => {
                                let value = e.target.value;
                                onChange(id, value);
                            }}
                        >
                            <option>Weekly</option>
                            <option>Fortnightly</option>
                            <option>Monthly</option>
                        </Form.Control>
                    </Form.Group>
                )}
            />
        );
    }
}
